<template>
    <div class="popup">
        <div v-for="(popup, index) in messages" v-show="popup.visible" :key="index" class="popup-interval">
            <div class="popup-header" :class="popup.type === SUCCESS ? 'popup-success' : 'popup-error'">
                {{ popup.header }} <i class="icon-close" @click.prevent="closePopup(popup)"></i>
            </div>
            <div class="popup-body" :class="popup.type === SUCCESS ? 'popup-success' : 'popup-error'">
                {{ popup.text }}
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapState, mapActions } from 'vuex';
import { SUCCESS } from '../../constants';

export default {
    constants: {
        SUCCESS,
    },

    computed: {
        ...mapState('popup', {
            messages: 'popupMessages',
        }),
    },

    methods: {
        ...mapActions({
            closePopup: 'popup/closePopup',
            clearMessages: 'popup/clearMessages',
        }),
    },
};
</script>
